import {EnumUtilities} from "../../../../utilities/enum-utilities";

export class EnumValueToNameValueConverter {
    public toView(value: number, e: any): string {
        return EnumUtilities.getName(e, value);
    }
}